import { SrSalesOrderType } from '@plato/data/starrocks/types';
import type React from 'react';
import { Link } from 'react-router-dom';
import { formatOrderId } from '../../../lib/order-helpers.ts';
import { useAppConfig } from '../../acl/acl-provider.tsx';
import { useDrawers } from '../../drawers/all-drawers.tsx';

type Props = {
    transactionId: string;
    type: SrSalesOrderType;
};

const getTransactionUrl = (type: SrSalesOrderType, id: string) => {
    if (type === SrSalesOrderType.QUOTE) {
        return `/quotes/${id}`;
    }

    if (type === SrSalesOrderType.ORDER) {
        return `/orders/${id}`;
    }

    return ``;
};

export const QuoteOrderLink: React.FC<Props> = ({ type, transactionId }) => {
    const { openOrderQuoteDetails } = useDrawers();
    const appConfig = useAppConfig();

    return (
        <Link
            className="text-blue-700 hover:underline text-sm"
            to={getTransactionUrl(type, transactionId)}
            onClick={(e) => {
                if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    openOrderQuoteDetails(type, transactionId);
                }

                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }}
        >
            {formatOrderId(appConfig, transactionId)}
        </Link>
    );
};

export const OrderLink = (props: Omit<Props, 'type'>) => (
    <QuoteOrderLink type={SrSalesOrderType.ORDER} {...props} />
);

export const QuoteLink = (props: Omit<Props, 'type'>) => (
    <QuoteOrderLink type={SrSalesOrderType.QUOTE} {...props} />
);
